import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import RedeemProgress from '../../RedeemProgress/RedeemProgress';
import { Button } from 'common/components/index';
import commonMessages from 'common/messages/messages';
import { RedeemType } from 'common/constants/service';
import { DurationUnit } from 'common/interfaces/common';
import { CustomTheme } from 'common/ui/interfaces';
import usePermissionContext from 'common/hooks/context/usePermissionContext';

const useStyles = makeStyles((theme: CustomTheme) => ({
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
  },
  headerActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: `${theme.spacing(2)}px`,
    paddingTop: theme.spacing(3),
  },
}));

interface IRedeemSubHeader {
  handleOnRedeemClick?: () => void;
  limited?: boolean;
  redeemType?: RedeemType;
  redeemDurationUnit?: DurationUnit;
  totalToRedeem: number;
  availableToRedeem: number;
  disabled?: boolean;
}

const RedeemSubHeader: FC<IRedeemSubHeader> = ({
  handleOnRedeemClick,
  limited = false,
  redeemType,
  totalToRedeem,
  redeemDurationUnit,
  availableToRedeem,
  disabled = false,
}) => {
  const classes = useStyles();
  const { MEMBER_SESSION_REDEEM } = usePermissionContext();
  const intl = useIntl();

  return (
    <Box className={classes.header}>
      <Box>
        <RedeemProgress
          limited={limited}
          redeemType={redeemType}
          redeemUnit={redeemDurationUnit}
          totalToRedeem={totalToRedeem}
          availableToRedeem={availableToRedeem}
        />
      </Box>

      {MEMBER_SESSION_REDEEM && Boolean(handleOnRedeemClick) ? (
        <Box className={classes.headerActions}>
          <Button
            disabled={disabled}
            color="primary"
            variant="contained"
            fullWidth
            size="medium"
            onClick={handleOnRedeemClick}
          >
            {intl.formatMessage(commonMessages.redeemBtn)}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default RedeemSubHeader;
